import LightTooltip from 'Components/LightTooltip'
import React from 'react'
import info from './assets/info.svg'

const ToolTipInformation = ({ width = '300px', message, style = {} }) => {
  return (
    <LightTooltip
      sx={{
        '.MuiTooltip-tooltip': {
          maxWidth: width,
        },
      }}
      title={message}
      placement="right">
      <img
        src={info}
        alt="info-circle"
        style={{
          width: '14px',
          height: '14px',
          cursor: 'pointer',
          marginLeft: '8px',
          ...style,
        }}
      />
    </LightTooltip>
  )
}

export default ToolTipInformation
